import { createFileRoute } from "@tanstack/react-router";
import { GlobalShell } from "~/components/GlobalShell";
import { useRouter, useSearchParams } from "~/components/navigation";

export const Route = createFileRoute("/reset-password")({
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const router = useRouter();
  const token = useSearchParams().get("token") ?? "";

  return (
    <GlobalShell>
      <div className="flex items-center justify-center">
        <div className="card bg-base-100 w-96 shadow-xl max-w-[90vw]">
          <form
            className="card-body"
            onSubmit={(e) => {
              e.preventDefault();
              router.push(
                `/reset-password-confirm?token=${encodeURIComponent(token)}`,
              );
            }}
          >
            <h2 className="card-title w-full text-center justify-center">
              Reset Your Password
            </h2>
            <p>Click the button below to reset your password.</p>
            <button className="btn btn-primary" type="submit">
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </GlobalShell>
  );
}
